export const ModernToggle = ({
  id,
  label,
  active,
  onChange = () => {},
  isDisabled = false,
  additionalClasses = '',
}) => {
  return (
    <div
      className={`foundry--toggles toggle--modern 
        ${isDisabled ? 'disabled' : ''}
        ${ additionalClasses ? additionalClasses : ''}`}
    >
      <input
        className="toggles__input"
        id={id}
        type="checkbox"
        checked={active}
        onChange={onChange}
        disabled={isDisabled}
      ></input>
      <label className="toggles__label" htmlFor={id}>
        <div className="toggles__text">{label}</div>
      </label>
    </div>
  )
}
